import React from 'react'
import axios from 'axios'
import ReactTooltip from 'react-tooltip'
import Loading from '../general/Loading.js'
import Search from '../general/Search.js'
import GeneralTd from '../table-componets/GeneralTd.js'
import EmailTd from '../table-componets/EmailTd.js'
import PhoneNumberTd from '../table-componets/PhoneNumberTd.js'
import ButtonTd from '../table-componets/ButtonTd.js'
import ExportButton from "../ExportButton";

class Households extends React.Component {
  state = {
    searchText: '',
    page: 1,
    perPage: 20,
    totalPages: 1,
    orderBy: 'last_name',
    orderDir: 'ASC',
    households: [],
    loading: true
  }

  componentDidMount() {
    this.buildData()
  }

  buildData() {
    var that = this
    var params = {
      page: this.state.page,
      per_page: this.state.perPage,
      order_by: this.state.orderBy,
      order_dir: this.state.orderDir,
      primary: true,
      method: 'formatted_phone_number,avatar_url'
    }

    if (this.state.searchText) {
      params['search'] = this.state.searchText
    }

    axios({
      method:'get',
      url:'/members.json',
      params: params,
      responseType:'json'
    })
    .then(function(response) {
      that.setState({ loading: false })
      that.setState({ households: response.data })
      that.setState({ totalPages: Math.ceil(response.headers.total / that.state.perPage) })
    })
  }

  newSearch(newSearch) {
    this.setState({ searchText: newSearch })
    this.setState({ page: 1 })
    this.buildData()
  }

  sortData(orderBy) {
    if (orderBy == this.state.orderBy) {
      if (this.state.orderDir == 'DESC') {
        this.setState({ orderDir: 'ASC' })
      }
      else {
        this.setState({ orderDir: 'DESC' })
      }
    }
    else {
      this.setState({ orderBy: orderBy })
      this.setState({ orderDir: 'DESC' })
    }

    setTimeout(function() { this.buildData() }.bind(this), 50)
  }

  changePage(increment) {
    var page =  this.state.page +  increment
    this.setState({ page : page })
    setTimeout(function() { this.buildData() }.bind(this), 50)
  }

  renderPagination() {
    return(
      <div>
        <p>
          {'Showing page ' + this.state.page + ' of ' + this.state.totalPages}
        </p>
        {this.state.page == 1 &&
          <a className='btn btn-default disabled'>
            <i className='material-icons progress-bar-icon'>
              keyboard_arrow_left
            </i>
          </a>
        }
        {this.state.page != 1 &&
          <button className='btn btn-default'
             onClick={ ()=> this.changePage(-1) }>
            <i className='material-icons progress-bar-icon'>
              keyboard_arrow_left
            </i>
          </button>
        }
        {this.state.page < this.state.totalPages &&
          <button className='btn btn-default'
             onClick={ ()=> this.changePage(1) }>
            <i className='material-icons progress-bar-icon'>
              keyboard_arrow_right
            </i>
          </button>
        }
        {this.state.page == this.state.totalPages &&
          <a className='btn btn-default disabled'>
            <i className='material-icons progress-bar-icon'>
              keyboard_arrow_right
            </i>
          </a>
        }
      </div>
    )
  }

  renderImg(household) {
    return (
      <img
        src={household.avatar_url}
        style={{ height: '32px', width: '32px' }}
        className='img-circle'
        alt={household.first_name}
      />
    )
  }

  renderBody() {
    var that = this
    var households = []

    _.forEach(this.state.households, function(household, index) {
      households.push(
        <tr key={index}>
          <td>
            <a className='styled-link' href={'/households/' + household.household_id}>
              {that.renderImg(household)}
            </a>
          </td>
          <td>
            {household.last_name}
            {household.imported_household_id &&
              <span data-tip='Imported household ID'>
                {' (' + household.imported_household_id + ')'}
                <ReactTooltip />
              </span>
            }
          </td>
          <GeneralTd fieldValue={household.first_name} />
          <EmailTd fieldValue={household.email}
                   fieldClassName='hidden-xs' />
          <PhoneNumberTd fieldValue={household.formatted_phone_number}
                         fieldClassName='hidden-xs' />
          <ButtonTd fieldName='VIEW'
                    fieldURL={'/households/' + household.household_id} />
        </tr>
      )
    })

    return (
      <tbody>
        {households}
      </tbody>
    )
  }

  render() {
    var that = this

    return(
      <div>
        <h1>Households</h1>
        <div className='row'>
          <Search
            newSearchCallback={(newSearch) => this.newSearch(newSearch) }/>
          <div className='col-md-9 pull-right'>
            <div className='pull-right'>
              <a className='btn btn-pink btn-raised btn-long margin-right-five'
                 href='/households/new'>
                ADD
              </a>
              <a className='btn btn-indigo btn-raised btn-long margin-right-five'
                 href='/members'>
                MEMBERS
              </a>
              <button className='btn btn-grey btn-raised btn-long dropdown-toggle hidden-xs hidden-sm'
                 data-toggle='dropdown'>
                <span className='margin-right-five'>
                  OPTIONS
                </span>
                <span className='caret'></span>
              </button>
              <ul className='dropdown-menu'>
                <li>
                  <a href='/members_importer'>
                    IMPORT
                  </a>
                  <ExportButton
                    url="/export/households?primary=true"
                  />
                </li>
              </ul>
              <br className='visible-xs visible-sm' />
            </div>
          </div>
        </div>
        <br />
        {that.state.households.length ? (
          <div>
            <table className='table table-clean table-white'>
             <thead>
                <tr>
                  <th />
                  <th>
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData('last_name'); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Primary Last Name"
                      tabIndex="0"
                      onKeyDown={(e) => { 
                        if (e.key === 'Enter' || e.key === ' ') { 
                          e.preventDefault(); 
                          this.sortData('last_name'); 
                        } 
                      }}
                    >
                      Primary<br />Last Name
                    </a>
                  </th>
                  <th>
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData('first_name'); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Primary First Name"
                      tabIndex="0"
                      onKeyDown={(e) => { 
                        if (e.key === 'Enter' || e.key === ' ') { 
                          e.preventDefault(); 
                          this.sortData('first_name'); 
                        } 
                      }}
                    >
                      Primary<br />First Name
                    </a>
                  </th>
                  <th className="hidden-xs">
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData('email'); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Email"
                      tabIndex="0"
                      onKeyDown={(e) => { 
                        if (e.key === 'Enter' || e.key === ' ') { 
                          e.preventDefault(); 
                          this.sortData('email'); 
                        } 
                      }}
                    >
                      Email
                    </a>
                  </th>
                  <th className="hidden-xs">
                    <a
                      onClick={(e) => { e.preventDefault(); this.sortData('phone_number'); }}
                      className="styled-link pointer-hand"
                      role="button"
                      aria-label="Sort by Phone Number"
                      tabIndex="0"
                      onKeyDown={(e) => { 
                        if (e.key === 'Enter' || e.key === ' ') { 
                          e.preventDefault(); 
                          this.sortData('phone_number'); 
                        } 
                      }}
                    >
                      Phone Number
                    </a>
                  </th>
                  <th></th>
                </tr>
              </thead>
              {this.renderBody()}
            </table>
            {this.renderPagination()}
          </div>
        ) : (
          <Loading loading={this.state.loading}
                   noDataMessage={this.props.noRecordsMessage} />
        )}
      </div>
    )
  }
}

export default Households
